import { useEffect, useRef } from 'react';
import { usePlaidLink } from 'react-plaid-link';

function PlaidLinkToken(props) {
  const { onPlaidExit, onPlaidSuccess, plaidLinkToken } = props;
  const config = {
    onSuccess: (public_token, metadata) => {
      onPlaidSuccess(public_token, metadata);
    },
    onExit: (err, metadata) => {
      onPlaidExit(err, metadata);
    },
    token: plaidLinkToken,
  };
  const { open, ready, error } = usePlaidLink(config);
  const openedToken = useRef(null);

  useEffect(() => {
    if (error) {
      onPlaidExit(error);
    }
  }, [error, onPlaidExit]);

  useEffect(() => {
    if (ready && openedToken.current !== plaidLinkToken) {
      openedToken.current = plaidLinkToken;
      open();
    }
  }, [open, plaidLinkToken, ready]);

  return null;
}

export default PlaidLinkToken;
